export const ANONYMOUS_POD = 'NAX';
export const NA1_POD = 'NA1';
